// extracted by mini-css-extract-plugin
export default {"thumbsContainer":"_24Sf1","thumbImageWrapper":"_2Ci7P","thumb":"_2ToZN","selectedThumb":"_3V0eE","thumbsArrows":"Sn5CY","prev":"_1bjOv","next":"_12H5z","newThumbsarrows":"_2TN9a"};